<template>
  <div>

  </div>
</template>

<script>
export default {
  name: 'Redirect',
  mounted () {
    let r = '/home'
    if (this.$auth.isAuthenticated && !this.$auth.user['https://australianwine.com/accept_age']) {
      r = '/register-profile'
      console.log('REDIRECT profile not complete, redirecting to profile after login')
    } else if (this.$cookies.get('connect-redirect')) {
      r = this.$cookies.get('connect-redirect')
      this.$cookies.remove('connect-redirect')
      console.log('REDIRECT email and profile complete - redirecting to ' + this.$cookies.get('connect-redirect') + ' after login')
    }

    if (r.substr(0, 4).toLowerCase() === 'http') {
      window.location.href = r
    } else {
      this.$router.push(r)
    }
  }
}
</script>

<style lang="scss"></style>
